export default __webpack_public_path__ + "static/carlos-3b692eef8e054c0df53d849d04252048.png";